import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const SkipLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.default,
  mixBlendMode: 'difference',
  position: 'absolute',
  transform: 'translate(-100%, 0)',
  '&:focus': {
    transform: 'translate(0, 0)',
  },
}));

const SkipToContent = () => {
  const { t } = useTranslation(['common']);
  return (
    <Box sx={{ zIndex: 1000, position: 'absolute', top: 0, width: '100%' }}>
      <SkipLink href='#main'>{t('SKIPTOCONTENT')}</SkipLink>
    </Box>
  );
};
export default SkipToContent;
